<template>
  <!-- <main class="app-container"> -->
    <router-view></router-view>
  <!-- </main> -->
</template>

<style scoped>
  .app-container {
    display: flex;
    min-height: 100vh;
    width: 100%;
  }
</style>